const ERROR_MAP = {
  // Auth/Permission
  'Admin or Manager role required': "You don't have permission to do this",
  'Admin role required': "You don't have permission to do this",
  'Not authorized': "You don't have permission to do this",
  'Unauthorized': "Please log in again",
  'Token expired': "Your session has expired. Please log in again",
  'Invalid credentials': "Incorrect email or password",
  'Could not validate credentials': "Your session has expired. Please log in again",

  // Validation
  'vendor_id required': "Please select a vendor",
  'title required': "Please enter a title",
  'Invalid email': "Please enter a valid email address",
  'Email already registered': "This email is already registered",
  'User already exists': "This email is already registered",

  // Resources
  'Project not found': "This project could not be found",
  'Proposal not found': "This proposal could not be found",
  'Invoice not found': "This invoice could not be found",
  'RFQ not found': "This quotation request could not be found",
  'Budget not locked': "Please lock the budget baseline first",

  // Generic
  'Something went wrong': "This action couldn't be completed. Please try again.",
  'Internal server error': "Something unexpected happened. Please try again.",
  'Network Error': "Unable to connect. Please check your internet connection.",
};

export function getErrorMessage(error) {
  // Handle axios error objects
  if (error?.response?.data?.detail) {
    const detail = error.response.data.detail;

    // Pydantic validation array
    if (Array.isArray(detail)) {
      return "Please check your form — one or more fields have invalid values";
    }

    // Object detail (plan limits, structured errors)
    if (typeof detail === 'object' && detail.message) {
      return detail.message;
    }

    // Direct string match
    if (typeof detail === 'string') {
      if (ERROR_MAP[detail]) return ERROR_MAP[detail];

      // Partial matches
      for (const [key, msg] of Object.entries(ERROR_MAP)) {
        if (detail.toLowerCase().includes(key.toLowerCase())) return msg;
      }
      return detail;
    }
  }

  // Handle plain string
  if (typeof error === 'string') {
    if (ERROR_MAP[error]) return ERROR_MAP[error];
    return error;
  }

  // Handle Error objects
  if (error?.message) {
    if (ERROR_MAP[error.message]) return ERROR_MAP[error.message];
    if (error.message === 'Network Error') return ERROR_MAP['Network Error'];
  }

  return "This action couldn't be completed. Please try again.";
}
